import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import { store } from "@/store/store";
import vuetify from "./plugins/vuetify";
import i18n from "@/i18n/i18n";
//@ts-ignore
import VeeValidate, { Validator } from "vee-validate";
import { validateLocaleEs } from "@/vee-validate/locale/es";
import PublicPathModule from '@/store/modules/public-path-module';
import { VueInstanceService } from './shared/services/vue-instance-service';
import { UtilsString } from './utils/utils-string';
import { UtilsDate } from "./utils/utils-date";


import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.orange.light.css';
//import '@/assets/css/dx.material.my-medical-diet-theme.css';

import "@/assets/css/dx.material.my-medical-diet-theme.css";

import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
import { ssmPermissionService } from "./shared/services/PermissionService";
import { UtilsURLS } from "./utils/utils-urls";
import { validatednionie } from "./vee-validate/customvalidates";
//https://github.com/xkjyeah/vue-google-maps/blob/vue2/README.md
import * as VueGoogleMap from 'vue2-google-maps';
//AIzaSyAEUBxJrwmT_yP1Udl7-7_t3vlS8mrV1t0
//AIzaSyCGLNvsiN0WrKKqd5j0RgqezlGt7nz2L9s
//@ts-ignore
Vue.use(VueGoogleMap, {
  load: {
    key: 'AIzaSyAEUBxJrwmT_yP1Udl7-7_t3vlS8mrV1t0',
    libraries: 'places', // Necesario si vas a usar la biblioteca de lugares
   // installComponents: true
  },
});

loadMessages(esMessages);

locale("es");

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg: string, vm: any, trace: any) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = "";
    //vm = null;
    trace = "";
  }
}

Vue.config.productionTip = false;
//@ts-ignore
PublicPathModule.setPublicPath(process.env.VUE_APP_PUBLIC_PATH as string);
//@ts-ignore
Vue.use(VeeValidate, { inject: false, delay: 1 });
// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize("es", validateLocaleEs);
Validator.extend("dni", validatednionie);
Validator.extend("nie", validatednionie);
import MaterialCard from "@/components/Cards/MaterialCard.vue";
import TableSelectCodigoDescripcion from "@/components/DinamicallyForm/TableSelectCodigoDescripcion.vue";
Vue.component("v-material-card", MaterialCard);
Vue.component("codigo-descripcion", TableSelectCodigoDescripcion);
Vue.prototype.$ValueOf = UtilsString.ValueOf;
Vue.prototype.$get_url = UtilsURLS.urls;
Vue.prototype.$IsEmptyTextPutThis = UtilsString.IsEmptyTextPutThis;
Vue.prototype.$log = console.log;
Vue.prototype.$format_date = UtilsDate.FormatDateBack;
Vue.prototype.$hasPermission = ssmPermissionService.hasPermission;
VueInstanceService.vueinstance = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h: any) => h(App)

}).$mount("#app");

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})
router.beforeEach((to: any, from: any, next: any) => {
  next();
});
